// Redimensiona/comprime uma imagem no cliente ANTES do upload.
// Motivo: o ambiente (nginx) rejeita corpos grandes (~>1MB → 502); fotos originais
// passam disso fácil. O backend já reduz para 400×400, então enviar uma versão
// menor não perde nada. Converte para JPEG (fundo branco onde há transparência)
// para garantir um payload pequeno. Retorna um data-URI; em qualquer falha,
// devolve o data-URI original (degrada com elegância).
export function downscaleImage (dataURL, maxDim = 800, quality = 0.85) {
  return new Promise((resolve) => {
    try {
      const img = new Image()
      img.onload = () => {
        try {
          let w = img.width
          let h = img.height
          if (w > maxDim || h > maxDim) {
            if (w >= h) {
              h = Math.round(h * maxDim / w)
              w = maxDim
            } else {
              w = Math.round(w * maxDim / h)
              h = maxDim
            }
          }
          const canvas = document.createElement('canvas')
          canvas.width = w
          canvas.height = h
          const ctx = canvas.getContext('2d')
          // fundo branco: transparência (logos PNG) vira branco em vez de preto no JPEG
          ctx.fillStyle = '#FFFFFF'
          ctx.fillRect(0, 0, w, h)
          ctx.drawImage(img, 0, 0, w, h)
          resolve(canvas.toDataURL('image/jpeg', quality))
        } catch (e) {
          resolve(dataURL)
        }
      }
      img.onerror = () => resolve(dataURL)
      img.src = dataURL
    } catch (e) {
      resolve(dataURL)
    }
  })
}
